{
  "common.back": "Back",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.comingSoon": "Coming soon",
  "common.create": "Create",
  "common.delete": "Delete",
  "common.goToDashboard": "Go to dashboard",
  "common.more": "More",
  "common.remove": "Remove",
  "common.save": "Save",
  "common.saved": "Saved",
  "common.search": "Search…",

  "mode.settings": "Settings",
  "mode.workspace": "Workspace",

  "login.title": "Log in to Divflow",
  "login.email": "Email",
  "login.password": "Password",
  "login.submit": "Log in",
  "login.mfaTitle": "Two-factor authentication",
  "login.mfaHint": "Enter the 6-digit code from your authenticator app, or one of your recovery codes.",
  "login.code": "Code",
  "login.verify": "Verify",

  "ws.name": "Divflow",
  "ws.settings": "Settings",
  "ws.invite": "Invite to workspace",
  "ws.status": "Status",
  "ws.dayMode": "Day mode",
  "ws.signOut": "Sign out",
  "ws.account": "Account",
  "ws.members": "Members",
  "ws.backups": "Backups",
  "ws.activity": "Activity",

  "projects.domains": "Domains",
  "projects.noDomains": "No custom domains yet",
  "projects.projects": "Projects",
  "projects.all": "All",
  "projects.archiveTitle": "Archive",
  "projects.newFolder": "New folder…",
  "projects.inviteTeam": "Invite your team",
  "projects.copyLink": "Copy link",
  "projects.linkCopied": "Link copied",
  "projects.new": "New project",
  "projects.namePlaceholder": "Project name",
  "projects.subdomainHint": "It will be online at {host}",
  "projects.sortViewed": "Last viewed by me",
  "projects.sortEdited": "Last edited",
  "projects.sortAlpha": "Alphabetically",
  "projects.viewed": "Viewed {when}",
  "projects.edited": "Edited {when}",
  "projects.live": "Live",
  "projects.draft": "Draft",
  "projects.down": "Down",
  "projects.archived": "Archived",
  "projects.openNewTab": "Open in new tab",
  "projects.visit": "Visit site",
  "projects.rename": "Rename",
  "projects.archive": "Archive",
  "projects.unarchive": "Unarchive",
  "projects.empty": "No projects yet. Create one and upload your site.",
  "projects.emptyArchive": "Archived projects show up here.",
  "projects.noResults": "No projects match your search.",

  "site.notFound": "This project doesn’t exist",
  "site.groupSite": "Site settings",
  "site.groupHosting": "Hosting",
  "site.general": "General",
  "site.versions": "Versions",
  "site.forms": "Forms",
  "site.domains": "Domains",
  "site.redirects": "Redirects",
  "site.headers": "Headers",
  "site.preview": "Preview",
  "site.openPreview": "Open preview",
  "site.openSite": "Open site",
  "site.visit": "Visit",
  "site.publish": "Publish",
  "site.publishHint": "Publish the version that is in preview",
  "site.upToDate": "The preview is already live",
  "site.publishedToast": "Published to {url}",
  "site.name": "Name",
  "site.subdomain": "Subdomain",
  "site.passwordProtect": "Password protect",
  "site.passwordHint": "Visitors need a password to see the site. Changing it signs everyone out.",
  "site.passwordOn": "This site is password protected.",
  "site.passwordPlaceholder": "Password",
  "site.passwordEnable": "Protect site",
  "site.passwordRemove": "Remove password",
  "site.passwordSet": "Password set",
  "site.passwordRemoved": "Password removed",
  "site.dangerZone": "Danger zone",
  "site.unpublish": "Unpublish",
  "site.unpublishHint": "Take the site offline on all domains. Your versions are kept.",
  "site.unpublished": "Site unpublished",
  "site.archiveHint": "Archived sites are not served and move to the Archive.",
  "site.delete": "Delete project",
  "site.deleteHint": "Deletes the project, its versions and its domains. This can’t be undone.",
  "site.deleteConfirm": "Type {slug} to confirm.",
  "site.deleted": "Project deleted",

  "versions.hint": "Upload your site as a .zip with an index.html. Each upload is a new version: publish it now or check it first in the preview.",
  "versions.drop": "Drop a .zip here",
  "versions.uploading": "Uploading…",
  "versions.choose": "Upload .zip",
  "versions.publishNow": "Publish right away",
  "versions.onlyZip": "Only .zip files can be uploaded",
  "versions.tooBig": "The file is larger than {mb} MB",
  "versions.publishedToast": "Version {n} is live",
  "versions.uploadedToast": "Version {n} is in preview",
  "versions.history": "History",
  "versions.none": "No versions yet.",
  "versions.number": "Version {n}",
  "versions.preview": "Preview",
  "versions.meta": "{when} · {files} files · {size}",
  "versions.setPreview": "Show in preview",
  "versions.previewSet": "Preview updated",
  "versions.openPreview": "Open preview",
  "versions.deleted": "Version deleted",

  "domains.hint": "Connect your client’s domain. SSL certificates are issued automatically once the domain points to the server.",
  "domains.defaultDomain": "Default domain",
  "domains.redirectsToPrimary": "Redirects to the primary domain",
  "domains.primary": "Primary",
  "domains.pending": "Waiting for DNS",
  "domains.verifiedAgo": "Checked {when}",
  "domains.verify": "Verify",
  "domains.checking": "Checking…",
  "domains.verifyAgain": "Check again",
  "domains.makePrimary": "Make primary",
  "domains.visit": "Visit",
  "domains.remove": "Remove",
  "domains.add": "Add domain",
  "domains.placeholder": "client.com",
  "domains.dnsIntro": "Add this record at the domain’s DNS provider:",
  "domains.dnsWait": "DNS changes can take a few minutes, sometimes hours. Then press Verify.",
  "domains.type": "Type",
  "domains.nameCol": "Name",
  "domains.value": "Value",
  "domains.copy": "Copy",
  "domains.copied": "Copied",
  "domains.found": "Found: {records}",
  "domains.activeToast": "{host} is connected",
  "domains.err.dns_not_found": "The domain has no DNS records yet",
  "domains.err.dns_wrong_target": "The domain doesn’t point to this server yet",
  "domains.err.http_token_mismatch": "The domain points here, but the check didn’t match. Try again in a minute",
  "domains.err.http_unreachable": "The server couldn’t be reached through this domain",
  "domains.err.dns_behind_proxy": "Connected through a proxy (DNS doesn’t point straight to the server)",
  "domains.err.check_skipped": "Check skipped (development)",
  "domains.err.unknown": "The domain couldn’t be verified",

  "rules.redirectsHint": "Redirect old URLs to new ones to keep their search ranking. Use * at the end to match a whole folder.",
  "rules.headersHint": "Add HTTP headers to the responses of a path, like X-Frame-Options. Use /* for the whole site.",
  "rules.from": "From",
  "rules.to": "To",
  "rules.status": "Status",
  "rules.path": "Path",
  "rules.name": "Name",
  "rules.value": "Value",
  "rules.addRedirect": "Add redirect",
  "rules.addHeader": "Add header",

  "forms.hint": "Any form on the site can send its submissions here. Point it to /_divflow/form; fields starting with _ are not stored.",
  "forms.none": "No submissions yet.",
  "forms.unnamed": "Form",

  "account.name": "Name",
  "account.email": "Email",
  "account.role": "Role",
  "account.password": "Password",
  "account.currentPassword": "Current password",
  "account.newPassword": "New password (10+ characters)",
  "account.changePassword": "Change password",
  "account.passwordChanged": "Password changed. Other sessions were signed out.",
  "account.mfa": "Two-factor authentication",
  "account.mfaHint": "Ask for a code from an authenticator app every time you log in.",
  "account.mfaOff": "Two-factor authentication is off.",
  "account.mfaOn": "On",
  "account.mfaSetup": "Set up",
  "account.mfaScan": "Scan this code with your authenticator app, or enter the key below, then type the 6-digit code.",
  "account.mfaEnable": "Turn on",
  "account.mfaDisable": "Turn off",
  "account.mfaDisabled": "Two-factor authentication turned off",
  "account.recoveryTitle": "Recovery codes",
  "account.recoveryHint": "Each code works once if you lose your phone. Save them somewhere safe: they won’t be shown again.",
  "account.recoverySaved": "I’ve saved them",

  "members.add": "Add member",
  "members.added": "Member added",
  "members.owner": "Owner",
  "members.member": "Member",
  "members.no2fa": "No 2FA",
  "members.lastLogin": "Last login {when}",
  "members.remove": "Remove from workspace",
  "members.tempPassword": "Temporary password (10+ characters)",

  "status.hint": "Every published site is checked every {n} minutes. You get an alert after two failed checks in a row.",
  "status.off": "The uptime monitor is off on this server.",
  "status.none": "No published sites yet.",
  "status.last": "{when} · {code} · {ms} ms",
  "status.noChecks": "Not checked yet",

  "backups.hint": "The database is copied continuously and everything else every night. A restore is tested every month.",
  "backups.notConfigured": "No backup report yet. Backups run on the server (deploy/backup) and report here.",
  "backups.ok": "All good",
  "backups.late": "Late",
  "backups.error": "Failing",
  "backups.unknown": "Not set up",
  "backups.litestream": "Database (continuous)",
  "backups.litestreamHint": "Continuous database replication (Litestream)",
  "backups.restic": "Nightly snapshot",
  "backups.resticHint": "Media, versions and settings with restic",
  "backups.check": "Weekly check",
  "backups.checkHint": "restic check of the repository",
  "backups.drill": "Monthly restore test",
  "backups.drillHint": "Restores the latest snapshot and checks the database",

  "time.never": "never",
  "time.justNow": "just now",
  "time.minutesAgo": "{n}m ago",
  "time.hoursAgo": "{n}h ago",
  "time.daysAgo": "{n}d ago",

  "errors.generic": "Something went wrong ({code})",
  "errors.network": "Can’t reach the server",
  "errors.internal": "Server error. Try again",
  "errors.csrf": "Request blocked. Reload the page",
  "errors.unauthorized": "Your session expired. Log in again",
  "errors.invalid_credentials": "Wrong email or password",
  "errors.account_locked": "Too many attempts. The account is locked for a while",
  "errors.too_many_attempts": "Too many attempts. Try again later",
  "errors.mfa_expired": "The login expired. Start again",
  "errors.mfa_invalid": "Wrong code",
  "errors.mfa_not_started": "Set up two-factor authentication first",
  "errors.password_weak": "Use at least 10 characters",
  "errors.owner_only": "Only the owner can do this",
  "errors.forbidden": "You can’t do this",
  "errors.email_invalid": "Invalid email",
  "errors.email_taken": "There is already a member with this email",
  "errors.cannot_delete_self": "You can’t remove yourself",
  "errors.user_not_found": "Member not found",
  "errors.site_not_found": "Project not found",
  "errors.slug_invalid": "Use lowercase letters, numbers and dashes",
  "errors.slug_reserved": "That subdomain is reserved for another service",
  "errors.slug_taken": "That subdomain is taken",
  "errors.settings_invalid": "Some rows are not valid",
  "errors.site_not_archived": "Archive the project first",
  "errors.confirm_mismatch": "The name doesn’t match",
  "errors.domain_invalid": "That’s not a valid domain",
  "errors.domain_reserved": "That domain can’t be used",
  "errors.domain_taken": "That domain is already connected",
  "errors.domain_not_found": "Domain not found",
  "errors.domain_not_active": "Verify the domain first",
  "errors.release_not_found": "Version not found",
  "errors.release_in_use": "That version is live or in preview",
  "errors.zip_required": "Choose a .zip file",
  "errors.zip_invalid": "The .zip file can’t be read",
  "errors.zip_no_index": "The .zip needs an index.html",
  "errors.zip_too_many_files": "The .zip has too many files",
  "errors.zip_too_large": "The .zip is too large",
  "errors.zip_unsafe_path": "The .zip has an unsafe file path",
  "errors.FST_ERR_CTP_BODY_TOO_LARGE": "The file is too large",
  "errors.name_invalid": "Invalid name",
  "errors.hostname_required": "Enter a domain",
  "errors.password_invalid": "Use at least 4 characters"
}
